// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".messages[data-v-384906bc]{background-color:#c6ded9;padding:1rem;max-height:380px;overflow-y:auto}.register-body[data-v-384906bc]  .register-group{margin:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
